<template lang="html">
  <div class="susseed">
    <img class="succeedImg" src="@/assets/image/activity/eitis/succeed.jpg" alt="">
    <!-- <div class="confirmBtn" v-show="!isInWx" @click="getClose">好的</div> -->
  </div>
</template>

<script>
  import utils from '@/utils/utils'

  export default {
    data() {
      return {
        isInWx: utils.browserChecker.isWx(),
      }
    },

    methods: {
      getClose() {
        window.opener = null
        window.open('', '_self')
        window.close();
      }
    }
  }
</script>

<style lang="css" scoped>
  .susseed {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .succeedImg {
    width: 100%;
    height: auto;
  }

  .text1 {
    font-size: 1.9rem;
    font-weight: 600;
    color: #1D2023;
    margin-top: 1rem;
  }

  .text2 {
    font-size: 1.8rem;
    font-weight: 600;
    color: #1D2023;
    text-align: center;
    margin: 0 3.5rem;
    margin-top: 2.15rem;
    line-height: 4rem;
  }

  .confirmBtn {
    position: fixed;
    left: 50%;
    bottom: 2rem;
    margin-left: -17.25rem;
    width: 34.5rem;
    height: 4rem;
    font-size: 1.7rem;
    color: #FCFCFC;
    background-color: #F7443F;
    border-radius: .4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 25.8rem;
  }
</style>